import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rt-bulk-selection-messages',
  templateUrl: './bulk-selection-messages.component.html',
  styleUrls: ['./bulk-selection-messages.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkSelectionMessagesComponent {
  @Input() public currentViewSelectedCount: number;
  @Input() public selectedCount: number;
  @Input() public hasBottomMargin: boolean = true;
  @Input() public hasTopMarginMedium: boolean = true;
  @Output() public clearSelection: EventEmitter<null> = new EventEmitter();
}
